import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class LayoutTemplateAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "LayoutTemplate";

  /**
   * Lưu layout của danh sách
   * @param {*} layout dòng dữ liệu có cấu trúc như trong db
   * @param {*} method phương thức gửi dữ liệu
   */
  async updateLayout(layout) {
    let request = {
      url: [this.getAPIUrl(), "customLayout"].join("/"), //role/users/1
      data: layout,
    };
    return httpClient.postAsync(request);
    //return this.request(url, method, layout);
  }
}

export default new LayoutTemplateAPI();
